/*
 * @Author: Tina Huang
 * @Date: 2025-03-20 15:21:01
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-03-21 09:30:14
 * @Description:
 */
type OBSIDIAN_TEMPLATE = {
  id: string
  title: string
  type: string
  detail: string
  cover: string
  file: string
}

export const ObsidianTemplates: OBSIDIAN_TEMPLATE[] = [
  {
    id: 'ob_t_0',
    title: '时间银行 · Time Banking',
    type: '',
    detail: '',
    cover: '',
    file: './ob-temps/test.zip',
  },
  {
    id: 'ob_t_1',
    title: '50天挑战 · 50 days challenge',
    type: '',
    detail: '',
    cover: '',
    file: '',
  },
]
